import { useRef, useState } from "react";
import "./ImageGallery.css"; 
const SWIPE_THRESHOLD = 50; // حداقل فاصله برای تشخیص سوایپ (px)

export default function MobileImageSlider({
  images = [],
  initialIndex = 0,
  showCounter = true,
  className = "",
}) {
  const [index, setIndex] = useState(initialIndex);
  const [dragX, setDragX] = useState(0);
  const [dragging, setDragging] = useState(false);
  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const isLockedRef = useRef(false); // قفل جهت اسکرول (عمودی/افقی)

  const maxIndex = Math.max(images.length - 1, 0);

  const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

  const goTo = (i) => setIndex(clamp(i, 0, maxIndex));
  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);

  // لمس شروع
  const onTouchStart = (e) => {
    if (!images.length) return;
    const t = e.touches[0];
    startXRef.current = t.clientX;
    startYRef.current = t.clientY;
    setDragging(true);
    setDragX(0);
    isLockedRef.current = false;
  };

  // لمس حرکت
  const onTouchMove = (e) => {
    if (!dragging) return;

    const t = e.touches[0];
    const dx = t.clientX - startXRef.current;
    const dy = t.clientY - startYRef.current;

    // قفل جهت: اگر حرکت افقی غالب شد، اسکرول صفحه رو متوقف کن
    if (!isLockedRef.current) {
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
        isLockedRef.current = true;
      } else if (Math.abs(dy) > Math.abs(dx)) {
        // حرکت عمودی غالب: اجازه بده صفحه اسکرول شه
        return;
      }
    }

    if (isLockedRef.current) {
      e.preventDefault(); // جلوگیری از اسکرول عمودی
      setDragX(dx);
    }
  };

  // لمس پایان
  const onTouchEnd = () => {
    if (!dragging) return;

    if (dragX > SWIPE_THRESHOLD) {
      prev();
    } else if (dragX < -SWIPE_THRESHOLD) {
      next();
    }

    setDragging(false);
    setDragX(0);
  };

  if (!images.length) return null;

  return (
    <div className={`mobile-slider ${className}`}>
      {/* شمارنده بالای تصویر */}
      {showCounter && (
        <div className="ms-counter">
          {index + 1} / {images.length}
        </div>
      )}

      <div
        className="ms-viewport "
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div
          className="ms-track "
          style={{
            width: `${images.length * 100}%`,
            transform: `translateX(calc(${-index * 100}% + ${dragX}px))`,
            transition: dragging ? "none" : "transform 300ms ease",
          }}
        >
          {images.map((src, i) => (
            <div className="ms-slide p-2" key={i}>
              <div className="ms-media">
                <img src={`${src}`} alt={`product-${i + 1}`} loading="lazy" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* نقاط اندیکاتور */}
      <div className="ms-dots">
        {images.map((_, i) => (
          <button
            key={i}
            className={`ms-dot ${i === index ? "active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
